import { render, staticRenderFns } from "./TxtSlider.vue?vue&type=template&id=4dd70aec&scoped=true&"
import script from "./TxtSlider.vue?vue&type=script&lang=js&"
export * from "./TxtSlider.vue?vue&type=script&lang=js&"
import style0 from "./TxtSlider.vue?vue&type=style&index=0&id=4dd70aec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd70aec",
  null
  
)

export default component.exports